var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopySimple(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31152 2.81201C5.31152 2.29424 5.73126 1.87451 6.24902 1.87451H17.1871C17.7048 1.87451 18.1246 2.29424 18.1246 2.81201V13.7496C18.1246 14.2674 17.7048 14.6871 17.1871 14.6871C16.6693 14.6871 16.2496 14.2674 16.2496 13.7496V3.74951H6.24902C5.73126 3.74951 5.31152 3.32978 5.31152 2.81201Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.18652 5.93726C2.18652 5.41949 2.60626 4.99976 3.12402 4.99976H14.062C14.5797 4.99976 14.9995 5.41949 14.9995 5.93726V16.8748C14.9995 17.3925 14.5797 17.8123 14.062 17.8123H3.12402C2.60626 17.8123 2.18652 17.3925 2.18652 16.8748V5.93726ZM4.06152 6.87476V15.9373H13.1245V6.87476H4.06152Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySimple);
export default __webpack_public_path__ + "static/media/CopySimple.9619bba3ec73b8251c85a4f3c852410f.svg";
export { ForwardRef as ReactComponent };